import {
    GET_CONTACTS,
    GET_CONTACTS_SUCCESS,
    GET_CONTACTS_FAILURE,
    UPDATE_CONTACT_STATUS,
    UPDATE_CONTACT_STATUS_SUCCESS,
    UPDATE_CONTACT_STATUS_FAILURE,
    ADD_CONTACT,
    ADD_CONTACT_SUCCESS,
    ADD_CONTACT_FAILURE,
    EDIT_CONTACT,
    EDIT_CONTACT_SUCCESS,
    EDIT_CONTACT_FAILURE,
    DELETE_CONTACT,
    DELETE_CONTACT_SUCCESS,
    DELETE_CONTACT_FAILURE,
    UPDATE_CONTACT_ORDER_STATUS,
    UPDATE_CONTACT_ORDER_STATUS_SUCCESS,
    UPDATE_CONTACT_ORDER_STATUS_FAILURE
} from "../Constants"

const init = {
    data: {},
    status_data: {},
    edit_data: {},
    add_data: {},
    delete_data:{}
};

const ContactUsReducer = (state = init, action) => {
    switch (action.type) {
        case GET_CONTACTS:
            return { ...state, loading: true };
        case GET_CONTACTS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_CONTACTS_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case UPDATE_CONTACT_STATUS:
            return { ...state, loading: true };
        case UPDATE_CONTACT_STATUS_SUCCESS:
            return { ...state, loading: false, status_data: action.payload };
        case UPDATE_CONTACT_STATUS_FAILURE:
            return { ...state, loading: false, status_data: action.payload };
        case ADD_CONTACT:
            return { ...state, loading: true };
        case ADD_CONTACT_SUCCESS:
            return { ...state, loading: false, add_data: action.payload };
        case ADD_CONTACT_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case EDIT_CONTACT:
            return { ...state, loading: true };
        case EDIT_CONTACT_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_CONTACT_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case DELETE_CONTACT:
            return { ...state, loading: true };
        case DELETE_CONTACT_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_CONTACT_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };
        case UPDATE_CONTACT_ORDER_STATUS:
            return { ...state, loading: true };
        case UPDATE_CONTACT_ORDER_STATUS_SUCCESS:
            return { ...state, loading: false, order_data: action.payload };
        case UPDATE_CONTACT_ORDER_STATUS_FAILURE:
            return { ...state, loading: false, order_data: action.payload };
        default:    
            return state;
    }
};

export default ContactUsReducer;